// extracted by mini-css-extract-plugin
export default {"button":"SubmitButton_button__ZxeNn","small":"SubmitButton_small__Db4of"};